// @ts-strict-ignore
/** @jsx jsx */
/** @jsxFrag null */
import {jsx} from 'panel';

import {ItemsMenuEl} from 'common/components/items-menu';
import {ToggleEl} from 'common/components/toggle';
import {ToggleTheme} from 'common/components/toggle/types';
import {SHORT_WINDOW_HEIGHT} from 'common/constants';

import {DateTab} from '../types';
import type {DateBucketPane} from './index';

export function template(this: DateBucketPane) {
  const {t} = this.getContext(`i18n`);
  return (
    <div sel='.mp-date-bucket-pane' class={{'short-window': window.innerHeight <= SHORT_WINDOW_HEIGHT}}>
      <ToggleEl
        sel='.toggle-el'
        attrs={{
          theme: ToggleTheme.TabBar,
          options: [
            {
              label: t(`query-builder.buckets.time-unit`),
              value: DateTab.Unit,
              tooltipLabel: t(`query-builder.buckets.time-unit-tooltip`),
            },
            {
              label: t(`query-builder.buckets.iso-time`),
              value: DateTab.Iso,
              tooltipLabel: t(`query-builder.buckets.iso-time-tooltip`),
            },
          ],
          selected: this.params.unit ? DateTab.Unit : DateTab.Iso,
        }}
        on={{
          select: (ev) => this.handleTabClick(ev),
        }}
      />
      {this.params.unit && (
        <ItemsMenuEl
          props={{sections: this.getItemsMenuSections()}}
          on={{
            clickItem: (ev) => this.handleClickUnit(ev),
          }}
        />
      )}
      <div sel='.bucket-preview'>{this.getPreviewForUnit(this.params.unit)}</div>
    </div>
  );
}
